import './ui/all-ui';
import { Game } from "./game/game";
import { Sounds } from './lib/sounds';
import { UIState } from './ui/root-component';
async function init() {
    await Game.preload();
    const game = new Game();
    // Global game to make events and such easier.
    window.game = game;
    const root = document.querySelector('root-component');
    game.setCanvas(root.shadowRoot?.querySelector('canvas'));
    game.onLevelChange = (levelName, attemptNum) => {
        root.levelName = levelName;
        root.levelAttemptNumber = attemptNum;
    };
    root.addEventListener('players-selected', (event) => {
        console.log('players selected');
        game.selectPlayers(event.detail);
    });
    root.addEventListener('hide-title', () => {
        root.uiState = UIState.Customizing;
        Sounds.setSongs([]);
    });
    root.addEventListener('select-customization', (event) => {
        console.log('start game');
        game.playerVisualInfo = event.detail;
        game.start();
    });
}
init();
